import { Drawer as MuiDrawer } from '@mui/material';
import { FC } from 'react';
import { useEscapeKey } from '@csp/csp-web-hooks';
import { Loading } from '../../feedback/progress/Loading';
import { LoadingOverlay } from '../../feedback/progress/LoadingOverlay';
import { Grid } from '../../layout/grid/Grid';
import { useMediaQ } from '../../../hooks/useMediaQ';
import { SxProps } from '../../../common/system/SxProps';
import { DrawerHeaderWide } from './DrawerHeaderWide';
import { TemporaryDrawerWideMapper } from './mapper/TemporaryDrawerWideMapper';
import { TemporaryDrawerWideProps } from './model/TemporaryDrawerWideProps';

export const TemporaryDrawerWide: FC<TemporaryDrawerWideProps> = ({
  subHeader,
  header,
  onClose,
  anchor = 'right',
  id,
  fullWidth = false,
  minWidth = 'inherit',
  ariaLabelClose,
  isLoadingInitial,
  isLoading,
  size = 'large',
  children,
  preventDrawerClose,
  ...props
}) => {
  const mdUp = useMediaQ('lg', 'down');
  const lgUp = useMediaQ('lg', 'up');
  const lgUpWidth = TemporaryDrawerWideMapper.calcSizeLgUpWidth(size);

  const sx: SxProps = {
    '.MuiDrawer-paperAnchorRight': {
      overflowX: 'hidden',
      width: TemporaryDrawerWideMapper.calcWidth(fullWidth, mdUp, lgUp, size),
      minWidth,
    },
  };

  const { ref } = useEscapeKey<HTMLDivElement>(preventDrawerClose ? undefined : onClose);

  return (
    <MuiDrawer sx={sx} id={id} anchor={anchor} ref={ref} {...props}>
      <>
        {header && (
          <DrawerHeaderWide header={header} subHeader={subHeader} onClose={onClose} ariaLabelClose={ariaLabelClose} />
        )}
        <LoadingOverlay isLoading={isLoading} width={lgUpWidth} />

        {!isLoading && (
          <Loading isLoading={isLoadingInitial} p={0}>
            <Grid container height="100vh">
              {children}
            </Grid>
          </Loading>
        )}
      </>
    </MuiDrawer>
  );
};
